/* eslint-disable @typescript-eslint/indent */
import { DivPlugin, withDivEditorChains } from '@doltech/ui/lib/figma/BlogEditor/plugins/DivPlugin';
import { withDeserializeHTML } from '@doltech/ui/lib/figma/DolEditor/deserializers/html-deserializer/withDeserializeHTML';
import { EditableVoidPlugin } from '@doltech/ui/lib/figma/DolEditor/elements/editable-blank-voids/EditableVoidBlankPlugin';
import { NoteElementPlugin } from '@doltech/ui/lib/figma/DolEditor/elements/note/plugin';
import { BlogTablePlugin } from '@doltech/ui/lib/figma/DolEditor/elements/table-blog/BlogTablePlugin';
import { withTableV2 } from '@doltech/ui/lib/figma/DolEditor/elements/table-blog/components/AdminView/withTableV2';
import { TablePDFPlugin } from '@doltech/ui/lib/figma/DolEditor/elements/table/pdf/TablePDFPlugin';
import { withBreakLinePlugin } from '@doltech/ui/lib/figma/DolEditor/handlers/break-line-no-style/withBreakLine';
import { ReadOnlyPlugin } from '@doltech/ui/lib/figma/DolEditor/handlers/read-only/ReadOnlyPlugin';
import { AlignPlugin } from '@doltech/ui/lib/slatePlugins/elements/align/AlignPlugin';
import { SoftBreakPlugin } from '@doltech/ui/lib/slatePlugins/handlers/soft-break/SoftBreakPlugin';
import { BoldPlugin } from '@doltech/ui/lib/slatePlugins/marks/bold/BoldPlugin';
import { ItalicPlugin } from '@doltech/ui/lib/slatePlugins/marks/italic/ItalicPlugin';
import { UnderlinePlugin } from '@doltech/ui/lib/slatePlugins/marks/underline/UnderlinePlugin';
import { withInlineVoid } from '@doltech/ui/lib/slatePlugins/plugins/inline-void/withInlineVoid';
import { HighlightPlugin } from '@doltech/ui/lib/slatePlugins/marks/highlight/HighlightPlugin';
import { TestModeEnum } from '@doltech/utils/lib/constants';
import * as React from 'react';

export const useTableCompletionPluginAndEditorChains = ({
  editorBlanks,
  no,
  isAdmin = false,
  isPdfContent = false,
}) => {
  const plugins = React.useMemo(() => {
    return [
      isAdmin ? null : ReadOnlyPlugin(),
      SoftBreakPlugin({
        rules: [
          {
            hotkey: 'shift+enter',
          },
        ],
      }),
      BoldPlugin(),
      ItalicPlugin(),
      HighlightPlugin(),
      UnderlinePlugin(),
      AlignPlugin(),
      DivPlugin({}),
      NoteElementPlugin(),

      isPdfContent
        ? TablePDFPlugin({
            isReadOnly: !isAdmin,
          })
        : BlogTablePlugin({
            isReadOnly: !isAdmin,
            isTableCompletion: true,
          }),
      EditableVoidPlugin(
        isAdmin
          ? {
              blanks: editorBlanks,
              questionNo: no,
            }
          : {
              blanks: editorBlanks,
              questionNo: no,
              readOnly: false,
              mode: TestModeEnum.ADMIN_SETUP,
              userAnswers: [],
              selectBlankIndex: undefined,
              onUserAnswerChange: () => {},
              onClickBlank: () => {},
            }
      ),
    ].filter(Boolean);
  }, [editorBlanks, isAdmin, isPdfContent, no]);

  const editorChains = React.useMemo(() => {
    return [
      withInlineVoid({ plugins }),
      withDeserializeHTML({ plugins }), // This must be above any plugins handle copy/paste ( so it won't add default html handling )
      withBreakLinePlugin(), // this must ahead of list plugin ( so it won't override insert break behavior of list )
      withDivEditorChains(),
      withTableV2(),
    ];
  }, [plugins]);

  return {
    plugins,
    editorChains,
  };
};
